import { useContext } from "react";
import { InternationalizationContext } from "../contexts/intl/InternationalizationContext";

export function useInternationalization() {
  const intlContext = useContext(InternationalizationContext);
  return intlContext;
}